import {ModalBody, ModalFooter, ModalHeader} from "@heroui/modal";
import {Button} from "@heroui/button";
import React, {useEffect} from "react";
import {Link} from "@heroui/link";
import {useMonitoring} from "@/components/monitoring";
import {CHROME_EXTENSION_URL} from "@/components/DownloaderApp/utils";

function IconBxExtension(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path
                d="M19 10V7c0-1.103-.897-2-2-2h-3c0-1.654-1.346-3-3-3S8 3.346 8 5H5c-1.103 0-2 .897-2 2v3.881l.659.239C4.461 11.41 5 12.166 5 13s-.539 1.59-1.341 1.88L3 15.119V19c0 1.103.897 2 2 2h3.881l.239-.659C9.41 19.539 10.166 19 11 19s1.59.539 1.88 1.341l.239.659H17c1.103 0 2-.897 2-2v-3c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4h-2l-.003 5h-2.545c-.711-1.22-2.022-2-3.452-2s-2.741.78-3.452 2H5v-2.548C6.22 15.741 7 14.43 7 13s-.78-2.741-2-3.452V7h5V5a1 1 0 012 0v2h5v5h2a1 1 0 010 2z"/>
        </svg>
    );
}


export function ChromeExtensionPopup({data, onClose}) {
    const {track} = useMonitoring()

    useEffect(() => {
        track('ChromeExtensionPopup opened')
    }, []);

    function openInstallExtension() {
        track('ChromeExtensionPopup Extension button clicked')
        window.open(CHROME_EXTENSION_URL, '_blank');
        // onClose();
    }

    const isTwitchClipsSource = data?.source === 'twitch-clips';
    const contentLabel = data?.source === 'vodvod'
        ? 'VodVod playlists'
        : isTwitchClipsSource ? 'Twitch Clips in bulk' : 'Twitch VODs';

    const color = {
        style: {color: '#51fc1a'}
    }
    return (
        <>
            <ModalHeader className="flex flex-col gap-1">
        <span id="modal-title">
          One more thing...
        </span>
            </ModalHeader>
            <ModalBody className="">
                <p>
                    To download <b {...color}>{contentLabel}</b>, you need to <Link onPress={openInstallExtension}
                                                                                 className={'underline underline-offset-2'}
                                                                                 href={`#`}>
                    <b {...color}>install our browser extension</b>
                </Link>.
                </p>
                <p>
                    Once installed, refresh this page and try again.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button onPress={openInstallExtension} color="primary"
                        startContent={<IconBxExtension width={"20px"} height={"20px"}/>}>
                    Install extension
                </Button>
                <Button onPress={onClose}>
                    Close
                </Button>
            </ModalFooter>
        </>
    );
}